"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryManualCreate = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const switch_1 = require("client/components/material/switch");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/inventory/modules/inventory-create/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
require("./inventory-manual-create.less");
let InventoryManualCreate = class InventoryManualCreate extends react_1.Component {
    constructor() {
        super(...arguments);
        this.addToAllSitesSites = false;
        this.inventory = {
            addToAllSites: false,
            application: "",
            barcode: "",
            category: "",
            classes: "",
            signature1: "",
            signature2: "",
            signature3: "",
            description: "",
            ndc: "",
            refNdc: "",
            name: "",
            generic: "",
            manufacturer: "",
            type: "",
            form: "",
            strength: "",
            substance: "",
            uom: ""
        };
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/formulary");
        };
        this.handleSubmit = async () => {
            if (this.checkMissing()) {
                const saveResult = await store_1.inventoryCreateStore.manualCreateInventory(this.inventory);
                const { success, code, errProp } = saveResult;
                if (success) {
                    this.error = "";
                    const id = saveResult.inventoryId;
                    router_1.RouteManager.transitionTo(`/formulary/0/${id}`);
                }
                else {
                    this.error = code;
                    this.missing[errProp] = true;
                }
            }
        };
        this.handleToggle = () => {
            this.inventory.addToAllSites = !this.inventory.addToAllSites;
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            this.inventory[fieldName] = value;
            if (this.missing[fieldName] === true) {
                this.missing[fieldName] = false;
            }
            if (this.error.includes(fieldName)) {
                this.error = "";
            }
        };
        this.checkMissing = () => {
            let fieldsCompleted = true;
            const inventoryComparison = Object.keys(this.missing);
            /**
             * Iterate this.missing comparing to this.inventory to check if there is a value for
             * the current field.
             */
            this.missing = inventoryComparison.reduce((accu, property) => {
                if (!this.inventory[property]) {
                    accu[property] = true;
                }
                return accu;
            }, this.missing);
            for (const key in this.missing) {
                if (this.missing[key]) {
                    fieldsCompleted = false;
                    this.error = "Required Fields Missing.";
                }
            }
            return fieldsCompleted;
        };
    }
    componentWillMount() {
        this.error = "";
        this.missing = {
            // application   : false,
            barcode: false,
            // category      : false,
            ndc: false,
            refNdc: false,
            name: false,
            generic: false,
            manufacturer: false,
            type: false,
            form: false,
            strength: false,
            uom: false,
            description: false,
            classes: false
        };
    }
    render() {
        const { barcode, ndc, refNdc, name, generic, manufacturer, type, form, strength, uom, signature1, signature2, signature3, application, category, classes, description } = this.inventory;
        return (React.createElement("div", { className: "inventory" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Manually Add Medication" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "edit-inventory" },
                    React.createElement(ui_1.UiForm, { buttons: [
                            React.createElement(ui_1.UiButton, { onClick: this.handleCancel }, "Cancel"),
                            "Submit"
                        ], loading: store_1.inventoryCreateStore.inventory.loading, onSubmit: this.handleSubmit, error: this.error },
                        React.createElement("div", { style: { marginLeft: "20px" }, className: "inventory__form__description" }, "Manually insert Medication information below."),
                        React.createElement("div", { className: "main" },
                            React.createElement("h3", null, "IDENTIFICATION:"),
                            React.createElement("div", { className: "identification-info" },
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "NDC", missing: this.missing.ndc, placeholder: "Example: 70362-0722-01", onChange: this.handleChangeString("ndc"), value: ndc }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Ref. NDC", missing: this.missing.refNdc, placeholder: "Example: 70362-0722", onChange: this.handleChangeString("refNdc"), value: refNdc })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Name ", missing: this.missing.name, placeholder: "Example: Allzital", onChange: this.handleChangeString("name"), value: name }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Generic", missing: this.missing.generic, placeholder: "Example: butalbital", onChange: this.handleChangeString("generic"), value: generic })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Barcode", missing: this.missing.barcode, placeholder: "Example: 370362072213", onChange: this.handleChangeString("barcode"), value: barcode })))),
                        React.createElement("div", { className: "main" },
                            React.createElement("h3", null, "MEDICATION INFO:"),
                            React.createElement("div", { className: "identification-info" },
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Dosage Type", missing: this.missing.type, placeholder: "Example: Tablet", onChange: this.handleChangeString("type"), value: type }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Route / Form", missing: this.missing.form, placeholder: "Example: Oral", onChange: this.handleChangeString("form"), value: form })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Strength", missing: this.missing.strength, placeholder: "Example: 1", onChange: this.handleChangeString("strength"), value: strength }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Unit of Measure", missing: this.missing.uom, placeholder: "Example: mg/g", onChange: this.handleChangeString("uom"), value: uom })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Category", 
                                        // missing={this.missing.category}
                                        placeholder: "Example: ANDA", onChange: this.handleChangeString("category"), value: category }),
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Application", 
                                        // missing={this.missing.application}
                                        placeholder: "Example: ANDA203484", onChange: this.handleChangeString("application"), value: application })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", label: "Manufacturer", missing: this.missing.manufacturer, placeholder: "Example: Skylar Laboratories, LLC", onChange: this.handleChangeString("manufacturer"), value: manufacturer })))),
                        React.createElement("div", { className: "main" },
                            React.createElement("div", { className: "identification-info" },
                                React.createElement("h3", { style: { textAlign: "left" } }, "RX SIG:"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "", placeholder: "Example: Take two tablets every four hours", label: "SIG 1", onChange: this.handleChangeString("signature1"), value: signature1 || "" })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__long", placeholder: "Example: Take two tablets every four hours", label: "SIG 2", onChange: this.handleChangeString("signature2"), value: signature2 || "" })),
                                React.createElement("div", { className: "row" },
                                    React.createElement(text_field_1.MaterialTextField, { className: "defaults__long", placeholder: "Example: Take two tablets every four hours", label: "SIG 3", onChange: this.handleChangeString("signature3"), value: signature3 || "" })),
                                React.createElement("h3", { style: { textAlign: "left", width: "160px" } }, "MEDICATION DESCRIPTION:"),
                                React.createElement("div", { className: "notes-section" },
                                    React.createElement(text_area_1.MaterialTextArea, { className: "notes", missing: this.missing.description, onChange: this.handleChangeString("description"), placeholder: "Description Example: 1 TUBE in 1 CARTON (45802-151-53) > 120 g in 1 TUBE", value: description })),
                                React.createElement("h3", { style: { textAlign: "left", marginTop: "20px" } }, "MEDICATION CLASSES:"),
                                React.createElement("div", { className: "notes-section" },
                                    React.createElement(text_area_1.MaterialTextArea, { className: "notes", missing: this.missing.classes, onChange: this.handleChangeString("classes"), placeholder: "Classes Example: Barbiturate [EPC],Barbiturates [Chemical/Ingredient]", value: classes })),
                                React.createElement("div", { style: {
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                        marginTop: "15px"
                                    } },
                                    React.createElement("div", { className: "switch-add-all-sites" },
                                        React.createElement(switch_1.MaterialSwitch, { label: "Add to all pharmacies", value: "Add to all pharmacies", onChange: this.handleToggle }))))))))));
    }
};
__decorate([
    mobx_1.observable
], InventoryManualCreate.prototype, "addToAllSitesSites", void 0);
__decorate([
    mobx_1.observable
], InventoryManualCreate.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], InventoryManualCreate.prototype, "ndc", void 0);
__decorate([
    mobx_1.observable
], InventoryManualCreate.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], InventoryManualCreate.prototype, "inventory", void 0);
InventoryManualCreate = __decorate([
    mobx_react_1.observer
], InventoryManualCreate);
exports.InventoryManualCreate = InventoryManualCreate;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-manual-create/inventory-manual-create.tsx
// module id = 3499
// module chunks = 0